
import { Ticket } from "@/models/ticket";
import { TicketService } from "@/services";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			subject: "",
			sending: false
		};
	},
	props: {
		ticket: {
			type: Object as ()=>Ticket,
			required: true
		}
	},
	watch: {
		ticket: {
			immediate: true,
			handler(){
				this.subject = this.ticket.subject;
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			if (this.sending) return;
			try{
				this.sending = true;
				let result = await TicketService.updateSubject(this.ticket.id, this.subject);
				this.ticket.subject = result.subject;
				this.close();
			}catch(err){

			}
			this.sending = false;
		}
	}
});
